import "./Properties.css";

type TProps = {};

export function Properties({}: TProps) {
  return <div className="properties"></div>;
}
